import Swal from 'sweetalert2';
import axios from './axiosConfig';

export const denyPermission = () => {
  Swal.fire({
    title: 'Informacion',
    text: 'No tiene los permisos necesarios para acceder a esta pagina',
    icon: 'info',
    showConfirmButton: false,
    timer: 3000,
    allowOutsideClick: false,
    didOpen: () => Swal.showLoading(),
  });
};

const checkPerm = async (role, onAllowed, options = {}) => {
  const {
    onPermissions,
    onDenied = denyPermission,
    requiredBit = 'bitOpen',
  } = options;

  console.warn('Checking permission for role:', role);

  try {
    const res = await axios.post(
      process.env.REACT_APP_SERVER + '/usuarios/getconfiguracionpagina',
      JSON.stringify({ pagina: role }),
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('tkn')}`,
        },
        withCredentials: true,
      }
    );

    if (res.data.success === false) {
      Swal.fire({
        title: 'Error',
        text: res.data.message,
        icon: 'error',
        confirmButtonText: 'ok',
      });
      return { allowed: false, bits: null };
    }

    const bits = res.data.data?.[0] || null;

    if (onPermissions && bits) {
      onPermissions(bits);
    }

    const hasPermission = Boolean(bits?.[requiredBit]);

    if (hasPermission) {
      if (onAllowed) {
        await onAllowed(bits);
      }

      return { allowed: true, bits };
    }

    onDenied();
    return { allowed: false, bits };
  } catch (error) {
    console.error('Error al listar bit permisos:', error);
    return { allowed: false, bits: null, error };
  }
};

export default checkPerm;
